<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page" dir="rtl" [class.font-100]="receipt" [class.scale]="receipt">
  <div class="bb-page-shell">

    <div class="bb-page-header noPrint">
      <div class="bb-page-title-block">
        <h2 class="bb-page-title">{{ 'الفاتورة' | transloco }}</h2>
        <p class="bb-page-subtitle">{{ 'رقم الفاتورة: #' | transloco }}{{invoiceId}}</p>
      </div>

      <div class="bb-header-actions">
        <button onclick="window.print();" class="bb-btn bb-btn-primary">
          {{ 'اطبع' | transloco }}
        </button>
      </div>
    </div>

    <div class="bb-card bb-p-20">
      <div class="bb-flex bb-items-center bb-justify-between bb-wrap bb-gap-16 bb-mb-16">
        <div class="bb-text-stack">
          <h1 class="bb-page-title bb-m-0" [class.font-101]="receipt">{{ 'الفاتورة' | transloco }}</h1>
          <p class="bb-page-subtitle bb-m-0" [class.font-100]="receipt">{{ 'رقم الفاتورة: #' | transloco }}{{invoiceId}}</p>
          <p class="bb-page-subtitle bb-m-0" [class.font-100]="receipt">{{ 'التاريخ:' | transloco }} {{date}}</p>
        </div>

        <div class="bb-product-img-box">
          <img
            [class.img-101]="receipt"
            [defaultImage]="'/assets/loading-in.gif'"
            [lazyLoad]="userimage"
            [errorImage]="'/assets/logo-01.png'"
            [alt]="'product' | transloco"
          />
        </div>
      </div>

      <div class="bb-form-grid bb-mt-20">
        <div class="bb-card bb-p-16" [class.width-100]="receipt">
          <h3 class="bb-text-navy bb-font-bold bb-m-0 bb-mb-12" [class.font-101]="receipt">{{ 'من:' | transloco }}</h3>
          <p class="bb-m-0 bb-mb-8 bb-font-semibold" [class.font-100]="receipt">{{ 'BlueBox' | transloco }}</p>
          <p class="bb-m-0 bb-mb-8 bb-text-muted" [class.font-100]="receipt">01103325333</p>
          <p class="bb-m-0 bb-text-muted" [class.font-100]="receipt">bboxmart.com</p>
        </div>

        <div class="bb-card bb-p-16" [class.width-100]="receipt">
          <h3 class="bb-text-navy bb-font-bold bb-m-0 bb-mb-12" [class.font-101]="receipt">{{ 'الي:' | transloco }}</h3>
          <p class="bb-m-0 bb-mb-8 bb-font-semibold" [class.font-100]="receipt">{{clientname}}</p>
          <p class="bb-m-0 bb-mb-8 bb-text-muted" [class.font-100]="receipt">{{firstphone}}</p>
          <p class="bb-m-0 bb-mb-8 bb-text-muted" [class.font-100]="receipt">{{secphone}}</p>
          <p class="bb-m-0 bb-mb-8 bb-text-muted" [class.font-100]="receipt">
            {{ grov?.governorate_name_ar }}-{{ city?.city_name_ar }}
          </p>
          <p class="bb-m-0 bb-mb-8 bb-text-muted" [class.font-100]="receipt">{{address}}</p>

          <p class="bb-m-0 bb-mb-8 noPrint">
            <span class="bb-text-danger bb-font-bold">{{ 'ملحوظة:' | transloco }}</span> {{note}}
          </p>

          @if(delivery_hero != null){
          <p class="bb-m-0 noPrint">
            <span class="bb-font-bold">{{ 'مندوب الشحن:' | transloco }} {{delivery_hero}}</span>
          </p>
          }
        </div>
      </div>

      @if(receipt){
      <div class="bb-table-card bb-mt-20">
        <div class="bb-table-scroll">
          <table class="bb-table">
            <thead>
              <tr>
                <th class="mat-header-cell-custom">{{ 'المنتج' | transloco }}</th>
                <th class="mat-header-cell-custom">{{ 'الكمية' | transloco }}</th>
                <th class="mat-header-cell-custom">{{ 'الوحده' | transloco }}</th>
                <th class="mat-header-cell-custom">{{ 'الاجمالي' | transloco }}</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let product of products; let i = index">
                <td class="mat-cell-custom bb-font-bold">{{products[i]}}</td>
                <td class="mat-cell-custom">{{qty[i]}}</td>
                <td class="mat-cell-custom">{{prices[i]}} {{ 'جنيه مصري' | transloco }}</td>
                <td class="mat-cell-custom bb-price">{{prices[i] * qty[i]}} {{ 'جنيه مصري' | transloco }}</td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <td class="mat-cell-custom bb-font-bold" colspan="3">{{ 'المجموع الفرعي' | transloco }}</td>
                <td class="mat-cell-custom bb-price">{{sumprices}} {{ 'جنيه مصري' | transloco }}</td>
              </tr>
              <tr>
                <td class="mat-cell-custom bb-font-bold" colspan="3">{{ 'سعر التوصيل' | transloco }}</td>
                <td class="mat-cell-custom bb-price">{{deliveryfees}} {{ 'جنيه مصري' | transloco }}</td>
              </tr>
              <tr>
                <td class="mat-cell-custom bb-font-bold" colspan="3">{{ 'خصم' | transloco }}</td>
                <td class="mat-cell-custom bb-price">{{discount}} {{ 'جنيه مصري' | transloco }}</td>
              </tr>
              <tr>
                <td class="mat-cell-custom bb-font-bold" colspan="3">{{ 'الاجمالي' | transloco }}</td>
                <td class="mat-cell-custom bb-price">
                  {{sumprices + deliveryfees - discount }} {{ 'جنيه مصري' | transloco }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      }
      @else{
      <div class="bb-table-card bb-mt-20">
        <div class="bb-table-scroll">
          <table class="bb-table">
            <thead [class.thead]="receipt">
              <tr>
                <th class="mat-header-cell-custom" [class.font-101]="receipt">{{ 'المنتج' | transloco }}</th>
                <th class="mat-header-cell-custom" [class.font-101]="receipt">{{ 'الكمية' | transloco }}</th>
                <th class="mat-header-cell-custom" [class.font-101]="receipt">{{ 'الوحده' | transloco }}</th>
                <th class="mat-header-cell-custom" [class.font-101]="receipt">{{ 'الاجمالي' | transloco }}</th>
              </tr>
            </thead>

            <tbody [class.tbody]="receipt">
              <tr *ngFor="let product of products; let i = index">
                <td class="mat-cell-custom bb-font-bold" [class.font-100]="receipt">{{products[i]}}</td>
                <td class="mat-cell-custom" [class.font-100]="receipt">{{qty[i]}}</td>
                <td class="mat-cell-custom" [class.font-100]="receipt">{{prices[i]}} {{ 'جنيه مصري' | transloco }}</td>
                <td class="mat-cell-custom bb-price" [class.font-100]="receipt">
                  {{prices[i] * qty[i]}} {{ 'جنيه مصري' | transloco }}
                </td>
              </tr>
            </tbody>

            <tfoot [class.tfoot]="receipt">
              <tr>
                <td class="mat-cell-custom bb-font-bold" colspan="3" [class.font-101]="receipt">{{ 'المجموع الفرعي' | transloco }}</td>
                <td class="mat-cell-custom bb-price" [class.font-100]="receipt">{{this.sumprices}} {{ 'جنيه مصري' | transloco }}</td>
              </tr>
              <tr>
                <td class="mat-cell-custom bb-font-bold" colspan="3" [class.font-101]="receipt">{{ 'سعر التوصيل' | transloco }}</td>
                <td class="mat-cell-custom bb-price" [class.font-100]="receipt">{{deliveryfees}} {{ 'جنيه مصري' | transloco }}</td>
              </tr>
              <tr>
                <td class="mat-cell-custom bb-font-bold" colspan="3" [class.font-101]="receipt">{{ 'الخصم' | transloco }}</td>
                <td class="mat-cell-custom bb-price" [class.font-100]="receipt">{{discount}} {{ 'جنيه مصري' | transloco }}</td>
              </tr>
              <tr>
                <td class="mat-cell-custom bb-font-bold" colspan="3" [class.font-101]="receipt">{{ 'الاجمالي' | transloco }}</td>
                <td class="mat-cell-custom bb-price" [class.font-100]="receipt">
                  {{this.sumprices + deliveryfees - discount}} {{ 'جنيه مصري' | transloco }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      }

      <div class="bb-card bb-p-16 bb-mt-20 bb-bg-blue-soft">
        <div class="bb-text-danger bb-font-bold bb-text-center">
          <p class="bb-m-0 bb-mb-8">
            {{ '🎉 مبروك! رجعلك' | transloco }} {{(sumprices + deliveryfees - discount) * 0.05}} {{ 'جنيه — استخدمهم في طلبك القادم' | transloco }}
          </p>
          <p class="bb-m-0">
            {{ '🎉 Congratulations! You’ve got' | transloco }} {{(sumprices + deliveryfees - discount) * 0.05}} {{ 'EGP back — use it on your next order' | transloco }}
          </p>
        </div>
      </div>
    </div>
  </div>
</section>